import React from "react";
import { Trophy, Clock } from "lucide-react";

const winners = [
  { name: "Player_x7k", amount: "2.45 BTC", game: "Mega Jackpot", time: "2 min ago", crypto: "BTC" },
  { name: "CryptoKing", amount: "1.87 ETH", game: "Dragon's Gold", time: "5 min ago", crypto: "ETH" },
  { name: "VIP_Master", amount: "5,200 USDT", game: "Lucky Spin", time: "8 min ago", crypto: "USDT" },
  { name: "Whale_99", amount: "3.12 BTC", game: "Provably Fair Dice", time: "12 min ago", crypto: "BTC" },
  { name: "BitLord", amount: "0.95 BTC", game: "Crypto Roulette", time: "15 min ago", crypto: "BTC" },
  { name: "AnonWin", amount: "8,500 USDT", game: "Blackjack VIP", time: "18 min ago", crypto: "USDT" },
  { name: "SatoshiFan", amount: "1.23 BTC", game: "Slots Paradise", time: "22 min ago", crypto: "BTC" },
  { name: "HighRoller", amount: "4.56 ETH", game: "Baccarat Elite", time: "25 min ago", crypto: "ETH" },
];

const cryptoColors = {
  BTC: { bg: "rgba(247, 147, 26, 0.15)", text: "#F7931A", border: "rgba(247, 147, 26, 0.3)" },
  ETH: { bg: "rgba(98, 126, 234, 0.15)", text: "#627EEA", border: "rgba(98, 126, 234, 0.3)" },
  USDT: { bg: "rgba(38, 161, 123, 0.15)", text: "#26A17B", border: "rgba(38, 161, 123, 0.3)" },
};

export const MarqueeSection = () => {
  // Render a single set of winners - simplified for better performance
  const renderWinners = (keyPrefix) => (
    winners.map((winner, index) => {
      const colors = cryptoColors[winner.crypto] || cryptoColors.BTC;
      return (
        <div
          key={`${keyPrefix}-${index}`}
          className="inline-flex items-center gap-3 mx-4 rounded-xl px-4 py-3 border flex-shrink-0"
          style={{ 
            backgroundColor: colors.bg, 
            borderColor: colors.border,
            boxShadow: `0 0 20px ${colors.bg}`,
            minWidth: '280px',
            contain: 'content',
          }}
          aria-hidden="true"
        >
          <div 
            className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0"
            style={{ backgroundColor: colors.bg }}
          >
            <Trophy className="w-4 h-4" style={{ color: colors.text }} />
          </div>
          <div className="flex flex-col min-w-0">
            <span className="text-xs text-white font-semibold truncate">{winner.name}</span>
            <span className="text-[10px] text-[#71717A] truncate">{winner.game}</span>
          </div>
          <div className="flex flex-col items-end flex-shrink-0">
            <span className="text-sm font-bold whitespace-nowrap" style={{ color: colors.text }}>
              {winner.amount}
            </span>
            <span className="text-[10px] text-[#71717A] flex items-center gap-1 whitespace-nowrap">
              <Clock className="w-3 h-3" /> {winner.time}
            </span>
          </div>
        </div>
      );
    })
  );

  return (
    <section 
      data-testid="marquee-section" 
      className="relative py-4 bg-gradient-to-r from-[#0A0A0A] via-[#111111] to-[#0A0A0A] border-y border-white/10 overflow-hidden"
      aria-label="Recent winners"
    >
      {/* Gradient fade edges */}
      <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-[#0A0A0A] to-transparent z-10 pointer-events-none" aria-hidden="true" />
      <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-[#0A0A0A] to-transparent z-10 pointer-events-none" aria-hidden="true" />
      
      <div className="marquee-container" role="marquee" aria-live="off">
        <div className="marquee-content">
          {renderWinners("a")}
          {renderWinners("b")}
        </div>
      </div>
    </section>
  );
};

export const TrustBar = ({ t }) => {
  // Default English text as fallback
  const crypto = t?.crypto || {
    title: "Supported Cryptocurrencies"
  };
  const cryptos = [
    { 
      name: "Bitcoin", 
      symbol: "BTC", 
      color: "#F7931A",
      logo: (
        <svg viewBox="0 0 32 32" className="w-5 h-5" fill="#F7931A" aria-hidden="true">
          <path d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm7.189-17.98c.314-2.096-1.283-3.223-3.465-3.975l.708-2.84-1.728-.43-.69 2.765c-.454-.114-.92-.22-1.385-.326l.695-2.783L15.596 6l-.708 2.839c-.376-.086-.746-.17-1.104-.26l.002-.009-2.384-.595-.46 1.846s1.283.294 1.256.312c.7.175.826.638.805 1.006l-.806 3.235c.048.012.11.03.18.057l-.183-.045-1.13 4.532c-.086.212-.303.531-.793.41.018.025-1.256-.313-1.256-.313l-.858 1.978 2.25.561c.418.105.828.215 1.231.318l-.715 2.872 1.727.43.708-2.84c.472.127.93.245 1.378.357l-.706 2.828 1.728.43.715-2.866c2.948.558 5.164.333 6.097-2.333.752-2.146-.037-3.385-1.588-4.192 1.13-.26 1.98-1.003 2.207-2.538zm-3.95 5.538c-.533 2.147-4.148.986-5.32.695l.95-3.805c1.172.293 4.929.872 4.37 3.11zm.535-5.569c-.487 1.953-3.495.96-4.47.717l.86-3.45c.975.243 4.118.696 3.61 2.733z"/>
        </svg>
      )
    },
    { 
      name: "Ethereum", 
      symbol: "ETH", 
      color: "#627EEA",
      logo: (
        <svg viewBox="0 0 32 32" className="w-5 h-5" fill="#627EEA" aria-hidden="true">
          <path d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm7.994-15.781L16.498 4 9 16.22l7.498 4.353 7.496-4.354zM24 17.616l-7.502 4.351L9 17.617l7.498 10.378L24 17.616z"/>
        </svg>
      )
    },
    { 
      name: "Tether", 
      symbol: "USDT", 
      color: "#26A17B",
      logo: (
        <svg viewBox="0 0 32 32" className="w-5 h-5" fill="#26A17B" aria-hidden="true">
          <path d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm1.922-18.207v-2.366h5.414V7.819H8.595v3.608h5.414v2.365c-4.4.202-7.709 1.074-7.709 2.118 0 1.044 3.309 1.915 7.709 2.118v7.582h3.913v-7.584c4.393-.202 7.694-1.073 7.694-2.116 0-1.043-3.301-1.914-7.694-2.117zm0 3.59v-.002c-.11.008-.677.042-1.942.042-1.01 0-1.721-.03-1.971-.042v.003c-3.888-.171-6.79-.848-6.79-1.658 0-.809 2.902-1.486 6.79-1.66v2.644c.254.018.982.061 1.988.061 1.207 0 1.812-.05 1.925-.06v-2.643c3.88.173 6.775.85 6.775 1.658 0 .81-2.895 1.485-6.775 1.657z"/>
        </svg>
      )
    },
    { 
      name: "BNB", 
      symbol: "BNB", 
      color: "#F3BA2F",
      logo: (
        <svg viewBox="0 0 32 32" className="w-5 h-5" fill="#F3BA2F" aria-hidden="true">
          <path d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm-3.884-17.596L16 10.52l3.886 3.886 2.26-2.26L16 6l-6.144 6.144 2.26 2.26zM6 16l2.26-2.26L10.52 16l-2.26 2.26L6 16zm6.116 1.596l-2.263 2.26.003.003L16 26l6.146-6.144v-.001l-2.26-2.26L16 21.48l-3.884-3.884zM21.48 16l2.26-2.26L26 16l-2.26 2.26L21.48 16zm-3.188 0L16 13.706 13.706 16 16 18.294 18.294 16z"/>
        </svg>
      )
    },
    { 
      name: "Solana", 
      symbol: "SOL", 
      color: "#00FFA3",
      logo: (
        <svg viewBox="0 0 32 32" className="w-5 h-5" aria-hidden="true">
          <defs>
            <linearGradient id="sol-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#00FFA3"/>
              <stop offset="100%" stopColor="#DC1FFF"/>
            </linearGradient>
          </defs>
          <path fill="url(#sol-gradient)" d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zM9.925 19.687l.78-.78h12.59l-.78.78H9.925zm0-3.906l.78-.78h12.59l-.78.78H9.925zm12.59-3.125l-.78-.78H9.145l.78.78h12.59z"/>
        </svg>
      )
    },
    { 
      name: "Ripple", 
      symbol: "XRP", 
      color: "#23292F",
      logo: (
        <svg viewBox="0 0 32 32" className="w-5 h-5" fill="#FFFFFF" aria-hidden="true">
          <path d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm5.394-20.637l-2.964 2.964a3.406 3.406 0 01-4.856 0l-2.964-2.964H8.25l4.182 4.182a5.387 5.387 0 007.136 0l4.182-4.182h-2.356zm-10.788 9.274l2.964-2.964a3.406 3.406 0 014.856 0l2.964 2.964h2.36l-4.182-4.182a5.387 5.387 0 00-7.136 0l-4.182 4.182h2.356z"/>
        </svg>
      )
    },
  ];

  return (
    <section data-testid="trust-bar" className="py-6" aria-label="Supported cryptocurrencies">
      <div className="max-w-7xl mx-auto px-6">
        {/* Minimal title */}
        <p className="text-xs text-[#71717A] text-center uppercase tracking-[0.3em] mb-10 font-medium">
          {crypto.title}
        </p>
        
        {/* Crypto list - simplified without individual motion wrappers */}
        <div className="flex items-center justify-center gap-6 flex-wrap md:flex-nowrap" role="list" aria-label="Accepted cryptocurrencies">
          {cryptos.map((crypto) => (
            <div
              key={crypto.symbol}
              className="group flex items-center gap-2 cursor-default animate-fade-up"
              role="listitem"
              style={{ animationDelay: '0.1s' }}
            >
              {/* Crypto icon circle */}
              <div 
                className="w-9 h-9 rounded-full flex items-center justify-center transition-all duration-300 group-hover:scale-110 flex-shrink-0"
                style={{ 
                  backgroundColor: `${crypto.color}20`,
                  border: `1px solid ${crypto.color}40`
                }}
              >
                {crypto.logo}
              </div>
              
              {/* Name and symbol */}
              <div className="flex flex-col">
                <span className="text-xs font-medium text-[#A1A1AA] group-hover:text-white transition-colors duration-300 whitespace-nowrap">
                  {crypto.name}
                </span>
                <span 
                  className="text-[10px] font-['JetBrains_Mono']"
                  style={{ color: crypto.color }}
                >
                  {crypto.symbol}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
